var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"form-control",domProps:{"value":_vm.value},on:{"input":_vm.onChange}},[_c('option',[_vm._v("OK")]),_vm._v(" "),_c('option',[_vm._v("Fail")]),_vm._v(" "),_c('option',[_vm._v("N/A")])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c2eafc8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/parts/ChecksSelectComponent.vue
// module id = O6Bo
// module chunks = 0